import React from 'react'
import { Swipeable } from 'react-swipeable'

require('ta-semantic-ui/semantic/dist/components/button.css')
require('ta-semantic-ui/semantic/dist/components/image.css')
require('ta-semantic-ui/semantic/dist/components/icon.css')
require('ta-semantic-ui/semantic/dist/components/label.css')
require('ta-semantic-ui/semantic/dist/components/progress.css')
require('./styles.scss')

/**
 * Test
 * @extends React.PureComponent
 *
 * @param {Array.string} props.imageList - A list of images
 */
export class Flipbook extends React.PureComponent {
  /**
   * Test
   * @param {Array.string} props.imageList - A list of URLs to images
   * @param props
   * @param context
   */
  constructor(props, context) {
    super(props, context)

    this.state = {
      currentImage: 0
    }

    // Bind this to events
    this.handleBack = this.handleBack.bind(this)
    this.handleForward = this.handleForward.bind(this)
  }

  render() {
    return (
      <div className='flipbook-component ui vertical very fitted segment'>
        <Swipeable
          className='swipe-field'
          onSwipedRight={this.handleBack}
          onSwipedLeft={this.handleForward}
          nodeName='div'
        >
          <figure>
            <img
              onClick={this.handleForward}
              className='ui fluid image'
              src={
                this.props.imageList[this.state.currentImage].sources['865w']
              }
              srcSet={this.props.imageList[this.state.currentImage].srcSet}
              sizes={this.props.sizes}
              title={this.props.imageList[this.state.currentImage].caption}
              alt={this.props.imageList[this.state.currentImage].caption}
            />
            <figcaption className='ta caption'>
              {this.props.imageList[this.state.currentImage].caption}
            </figcaption>
          </figure>
        </Swipeable>

        <div className='controls'>
          <a
            onMouseUp={this.handleBack}
            className='ui basic icon large button '
          >
            <i className='left chevron icon' />
          </a>

          <span className='ui circular empty horizontal labels'>
            {this.props.imageList.map((element, index) => {
              return (
                <div
                  className={`ui circular empty ${
                    index === this.state.currentImage ? 'teal' : ''
                  } label`}
                  key={index}
                />
              )
            })}
          </span>

          <a
            onMouseUp={this.handleForward}
            className='ui icon basic large button'
          >
            <i className='right chevron icon' />
          </a>
        </div>
      </div>
    )
  }

  handleForward(event) {
    if (this.state.currentImage + 1 > this.props.imageList.length - 1) {
      this.setState({
        currentImage: 0
      })
      return
    }

    this.setState({
      currentImage: this.state.currentImage + 1
    })
  }

  handleBack(event) {
    if (this.state.currentImage - 1 < 0) {
      this.setState({
        currentImage: this.props.imageList.length - 1
      })
      return
    }

    this.setState({
      currentImage: this.state.currentImage - 1
    })
  }
}

Flipbook.propTypes = {}
// imageList: React.PropTypes.arrayOf(React.PropTypes.shape({
//   sources: React.PropTypes.object,
//   srcSet: React.PropTypes.string,
//   caption: React.PropTypes.string
// })),
// sizes: React.PropTypes.string
Flipbook.defaultProps = {}
